<pv-resident-toolbar
	backAction="custom"
	title="{{ 'general.add_item' | translate: { item: (taskName$ | async | language) } }}"
	(back)="goBack()"
/>

<section class="content">
	<ic-tasks-detail-view [formConfig]="form$ | async" [task]="task$ | async" (create)="onCreate($event)" />
</section>
